export default __webpack_public_path__ + "ubisoft-playtest-faq-banner-mobile.webp";